<template>
  <v-list flat class="SlcHelpMenu">
    <div class="SlcHelpMenu-top Grid u-ph4 u-pv4">
      <span class="u-lh3 u-h3">{{ $t("helpMenu.title") }} </span>
      <span
        class="Grid-cell u-mt4 u-h4 u-lh1 u-fw300 u-colorGreyDarken4"
        :class="isMobile ? 'u-mb1' : ''"
        >{{ $t("helpMenu.section") }}</span
      >
    </div>
    <v-list-tile
      v-for="(item, index) in linksConfig"
      class="Grid-cell u-sizeFill SlcHelpMenu-item"
      :key="`help-link-${index}`"
      :href="item.link"
      :target="item.target"
    >
      <v-list-tile-avatar>
        <v-icon class="SlcHelpMenu-itemIcon" v-text="item.icon"></v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          class="SlcHelpMenu-itemText"
          v-text="item.title"
        ></v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action v-if="isMobile">
        <v-icon color="grey-60">chevron_right</v-icon>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    linksConfig: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style>
.SlcHelpMenu {
  padding: 0 !important;
}

.SlcHelpMenu-top {
  padding: 16px !important;
}

.SlcHelpMenu-item a {
  padding: 0 16px 0 8px;
}

.SlcHelpMenu-item {
  border-top-color: #eee;
  border-top-style: solid;
  border-top-width: 1px;
}

.SlecHelpMenu-itemIcon,
.SlecHelpMenu-itemText {
  color: var(--color-grey-90);
}

.SlcHelpMenu-item:hover .SlcHelpMenu-itemIcon,
.SlcHelpMenu-item:hover .SlcHelpMenu-itemText {
  color: var(--color-blue);
}
</style>
